import { apiTokenService, AuthContext } from "@harvestr-api/common";

export const getGithubToken = async (ctx: AuthContext) => {
    const tokens = await apiTokenService.getApiTokens(
        { where: { source: "GITHUB" } },
        ctx
    );
    return tokens.length ? tokens[0]?.token : undefined;
};

export const getGithubBearer = async (
    ctx: AuthContext,
    gotTokenAlready?: string
): Promise<{ bearer: string }> => {
    let token;
    if (!gotTokenAlready) {
        token = await getGithubToken(ctx);
    } else {
        token = gotTokenAlready;
    }
    if (token === undefined) {
        throw new Error("getGithubBearer() : Not authorized");
    }
    return { bearer: token };
};
